module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Cart2-1fd64d063fe93863339d3d378b6ba2e4.svg";